import BasePolicy from '@/policies/BasePolicy.js';

export default class CourseLogEntryPolicy extends BasePolicy {
    before(user) {}

    viewAny(user, course) {
        return (
            user.hasPermissionTo('view all course log entries') ||
            user.hasPermissionViaCourseTo(course, 'view all course log entries')
        );
    }

    view(user, courseLogEntry) {
        return (
            user.hasPermissionTo('view a course log entry') ||
            user.hasPermissionViaCourseTo(courseLogEntry.course, 'view a course log entry')
        );
    }

    create(user, course) {
        return (
            user.hasPermissionTo('create a course log entry') ||
            user.hasPermissionViaCourseTo(course, 'create a course log entry')
        );
    }

    update(user, courseLogEntry) {
        return (
            (user.hasPermissionTo('edit a course log entry') ||
                user.hasPermissionViaCourseTo(courseLogEntry.course, 'edit a course log entry')) &&
            courseLogEntry.created_by === user.id
        );
    }

    delete(user, courseLogEntry) {
        return (
            (user.hasPermissionTo('view all course log entries') ||
                user.hasPermissionViaCourseTo(courseLogEntry.course, 'delete a course log entry')) &&
            courseLogEntry.created_by === user.id
        );
    }
}
